import { Checkbox } from "@/ui/form/primitives/checkbox"
import * as React from "react"
import clx from 'classnames'

type Props = {
    indeterminate?: boolean
    checked?: boolean
    id?: string
    label?: string
    disabled?: boolean
    textStyleType?: 'primary' | 'secondary'
    onChange?: React.ChangeEventHandler<HTMLInputElement>
}

export const FieldCheckbox = ({ indeterminate, checked, id, label, disabled, onChange, textStyleType }: Props) => {
    return (
        <div className="tw-flex tw-items-center tw-gap-2">
            <Checkbox 
                disabled={disabled}
                checked={checked}
                id={id}
                onChange={onChange}
                className="tw-flex-none"
                indeterminate={indeterminate}
            />

            <span
                className={clx("tw-text-base tw-text-content-base tw-text-left tw-flex-1", {
                    'tw-text-content-base': textStyleType === 'primary',
                    'tw-text-neutral': textStyleType === 'secondary',
                })}
            >
                {label}
            </span>
        </div>
    )
}


